<template>
  <div class="sp-layout-col" part="base" :class="classModifiers">
    <div v-if="showLabel" class="label">{{ label }}</div>
    <div class="wrapper" part="wrapper">
      <slot />
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { toBoolean } from "#ce/utils/props";
import { col as colProps, layoutCol as layoutColProps } from "./props";
import { useCol } from "./composables/useCol";

useCol();

const props = defineProps({ ...colProps, ...layoutColProps });

const showLabel = computed(() => toBoolean(props.showLabel));

const classModifiers = computed(() => ({
  "--foreground": toBoolean(props.foreground),
}));
</script>

<style lang="scss">
@use "./styles/col";

.sp-layout-col {
  display: flex;
  flex-direction: column;
  flex: 1 1 0;
  position: relative;

  .label {
    --color: hsla(0, 100%, 50%, 0.5);
    position: absolute;
    top: 0;
    right: 0;
    background: var(--color);
    border: 1px solid var(--color);
    color: white;
    line-height: 1;
    font-size: small;
    z-index: 999;
  }

  .wrapper {
    flex: 1 1 0;
    background: var(--sp-comp-layout-col-background);
    outline: var(--sp-comp-layout-col-outline);
    display: flex;
    flex-direction: column;
  }

  &.--foreground {
    .wrapper {
      z-index: var(--sp-comp-layout-col-foreground-z-index, 4);
      position: var(--sp-comp-layout-col-foreground-position, absolute);
      bottom: var(--sp-comp-layout-col-foreground-bottom, 0);
      top: var(--sp-comp-layout-col-foreground-top, auto);
      width: calc(100% - var(--column-gap-start) - var(--column-gap-end));
    }
  }
}
</style>
